import {ApiProtectedWS as http} from "../api/axios";
import {baseURL} from "../util/Constants";

class TimeReclassificationService {
  dailySummary(date: string) {
    return http.get(baseURL.activitiesapi.timeReclassification + "/daily-summary?date=" + date);
  }

  create(data: any) {
    return http.post(baseURL.activitiesapi.timeReclassification, data);
  }

  mine(status?: string) {
    return http.get(baseURL.activitiesapi.timeReclassification + "/mine" +
      (status && status !== "ALL" ? "?status=" + status : ""));
  }

  team(status?: string) {
    return http.get(baseURL.activitiesapi.timeReclassification + "/team" +
      (status && status !== "ALL" ? "?status=" + status : ""));
  }

  cancel(id: number) {
    return http.patch(baseURL.activitiesapi.timeReclassification + "/" + id + "/cancel");
  }

  decide(id: number, decision: string, comment: string) {
    return http.patch(baseURL.activitiesapi.timeReclassification + "/" + id + "/decision", {decision, comment});
  }
}

export default TimeReclassificationService;
